export const versao = "1.0.0.0";

export default versao;